import { useTranslation } from "react-i18next";
import { FrontendUserInfo, FrontendOrder } from "node-library/dist/portal";

import { SystemRole } from "node-library/dist/constants";
import {
	getStatusColors,
	getStatusString,
} from "../../../../helpers/orderHelper";
import { NeutralColor, SemanticColor } from "node-library/dist/colors";
import { DeleteIcon, UserIcon } from "../../../../common-components/svgIcons";
import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import { CustomCheckbox } from "../../../../common-components/inputs";
import {
	hasPermission,
	PermissionMap,
	Permissions,
} from "node-library/dist/permissions";

interface Props {
	order: FrontendOrder;
	user: FrontendUserInfo | undefined;

	selected: boolean;
	setSelected: (selected: boolean) => void;
	goToViewOrderDetails: () => void;

	deleteOrder: () => void;
}

export default function OrderRow(props: Props) {
	const { t: translation } = useTranslation();

	const {
		order,
		goToViewOrderDetails,
		user,
		selected,
		setSelected,
		deleteOrder,
	} = props;

	const userHasDeleteAccess: boolean = props.user
		? hasPermission(
				props.user?.role?.permissions as PermissionMap,
				Permissions.orders.delete
		  )
		: false;

	const statusString: string = getStatusString(order.orderStatus, translation);
	const statusColor: {
		backgroundColor: string;
		borderColor: string;
		textColor: string;
	} = getStatusColors(order.orderStatus);

	//currently only used for admin view - submitted orders so always have the date
	const submissionTimeStr: string = formatCustomDate(order.inserted as Date);

	const orderRowItem: React.ReactNode = (
		<div key={order.orderBarcodeId} className="order-list-view-row">
			<div onClick={(e) => e.stopPropagation()}>
				<CustomCheckbox
					className={``}
					label={``}
					checked={selected}
					setChecked={() => {
						setSelected(!selected);
					}}
				/>
			</div>
			<div
				className="order-list-view-item-row order-infos typography-body-01"
				onClick={() => {
					goToViewOrderDetails();
				}}
			>
				<div
					className={`order-list-view-row-barcode-section order-list-view-row-item `}
				>
					{order.orderBarcodeId}
				</div>
				<div className="order-list-view-row-item order-list-view-sample-count-row-item">
					{order.sampleCount}
				</div>
				<div className="order-list-view-row-item">
					{order.clientCompanyName}
					<div
						className="typography-caption"
						style={{
							display: "flex",
							gap: "5px",
							flexWrap: "wrap",
							color: NeutralColor.NEUTRAL_GREY_500,
						}}
					>
						<div style={{ display: "flex", gap: "3px", alignItems: "end" }}>
							<UserIcon
								size={20}
								strokeColor={NeutralColor.NEUTRAL_GREY_500}
								strokeWidth={1.5}
							/>
							{order.orderedBy}
						</div>
					</div>
				</div>
				<div className="order-list-view-row-item">
					{submissionTimeStr.split(" | ")[0]}
					<div className="typography-caption">
						{submissionTimeStr.split(" | ")[1]}
					</div>
				</div>
				<div className="order-list-view-row-item">
					<div
						className="typography-caption admin-sample-status-box admin-status-box-small"
						style={{
							backgroundColor: statusColor.backgroundColor,
							border: `1px solid ${statusColor.borderColor}`,
							color: statusColor.textColor,
						}}
					>
						{statusString}
					</div>
				</div>
				<div className="order-list-view-row-item">
					{userHasDeleteAccess && (
						<div
							style={{ display: "flex", justifyContent: "center", gap: "5px" }}
						>
							<div
								id={`delete-order=${order.orderBarcodeId}`}
								style={{ cursor: "pointer" }}
								onClick={(e) => {
									e.stopPropagation();
									deleteOrder();
								}}
							>
								<DeleteIcon></DeleteIcon>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);

	return orderRowItem;
}
